/*
 * View for Engines
 */

define([
  "marionette",
  "modules/accountAdmin/kbWizardModal/kbLocales/kbLocalesList/template/kbLocalesListTemplate.html",
], function (Marionette, KbLocalesListTemplate) {
  var KbLocalesListView = {};

  KbLocalesListView.kbLocalesLayout = Marionette.Layout.extend({
    template: KbLocalesListTemplate,
    regions: {
      list: "#kbLocaleList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
      "click #kbEditLocaleAdd": "addLocaleToKb",
    },

    showErrorMessage: function (errorMessage) {
      this.$el
        .find("#kbLocaleEditAddLanguageError")
        .append('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },

    clearErrors: function () {
      this.$el.find("h5.error-message").remove();
    },
  });

  return KbLocalesListView;
});
